import create from 'zustand';

const useTestSeriesStore = create((set) => ({
  modalInfo: {},
  isSkuInfoFetchedOnClient: false,
  isUamInfoFetchedOnClient: false,

  setModalInfo: (info) =>
    set((state) => {
      return { ...state, modalInfo: info };
    }),
  updateIsSkuFetched: (isSkuInfoFetchedOnClient) =>
    set((state) => {
      return { ...state, isSkuInfoFetchedOnClient };
    }),
  updateIsUamFetched: (isUamInfoFetchedOnClient) =>
    set((state) => {
      return { ...state, isUamInfoFetchedOnClient };
    })
}));

export default useTestSeriesStore;
